/* eslint-disable */
export const page404En = {
  'Error 404, this page can not be found...': 'Error 404, this page can not be found...',
  'Something wrong, you can back to ': 'Something wrong, you can back to ',
  'main page': 'main page'
};

export const page404Ru = {
  'Error 404, this page can not be found...': 'Ошибка 404, эта страница не может быть найдена...',
  'Something wrong, you can back to ': 'Что-то пошло не так, вы можете вернуться на ',
  'main page': 'главную страницу'
};
/* eslint-disable */
